/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Pending_DescInputs */

const en_fc_online_pending_desc = /** @type {(inputs: Fc_Online_Pending_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A hosted editor is not configured on this site yet. Download the official web build to run it locally, or use our desktop installation guide.`)
};

/**
* | output |
* | --- |
* | "A hosted editor is not configured on this site yet. Download the official web build to run it locally, or use our desktop installation guide." |
*
* @param {Fc_Online_Pending_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_pending_desc = /** @type {((inputs?: Fc_Online_Pending_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Pending_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_pending_desc(inputs)
});
export { fc_online_pending_desc as "fc.online.pending.desc" }